(function($) {
  var startDate = moment().add(local.booking.checkin_start, 'd').format('YYYY-MM-DD');
  var reservationRange = moment(startDate).add(local.booking.reservation_range, 'd').format('YYYY-MM-DD');

  var fb = new Booking({
    el: '#booking_form',
    baseURL: local.booking.domain,
    params: {
      propertyId: local.booking.property_id,
      onlineId: local.booking.online_id,
      checkin: startDate,
      checkout: reservationRange,
      numofadult: local.booking.numofadult,
      numofchild: local.booking.numofchild,
      numofroom: local.booking.numofroom,
      accesscode: local.booking.secret_code,
      lang: local.language.slice(0, 2)
    }
  });

  var mb = new Booking({
    el: '.mobile-booking-link',
    mode: 'attr',
    elAttr: 'href',
    baseURL: local.booking.domain,
    params: {
      propertyId: local.booking.property_id,
      checkin: startDate,
      checkout: reservationRange,
      numofroom: null,
      numofadult: null,
      numofchild: null,
      accesscode: local.secret_code
    },
  });

  var lb = new Booking({
    el: 'a.booking-link',
    mode: 'attr',
    elAttr: 'href',
    baseURL: local.booking.domain,
    params: {
      propertyId: local.booking.property_id,
      accesscode: local.booking.secret_code,
      checkin: startDate,
      checkout: reservationRange,
    }
  })
  
  var rl = new Booking({
    el: 'a.rate-link',
    mode: 'attr',
    elAttr: 'href',
    baseURL: local.booking.domain + 'rates',
    params: {
      propertyId: local.booking.property_id,
      accesscode: local.booking.secret_code,
      checkin: startDate,
      checkout: reservationRange,
    }
  })

  if (window.FormBooking === undefined) {
    window.FormBooking = fb;
  }

  if (window.MobileBooking === undefined) {
    window.MobileBooking = mb;
  }

  if (window.LinkBooking === undefined ) {
    window.LinkBooking = lb;
  }

  if (window.RateBooking === undefined) {
    window.RateBooking = rl;
  }
})(jQuery);